import type { ResolvedBetterstartConfig } from '@cli-types/core-engine/config.js'
import type { BetterstartIntegrationId } from '@cli-types/integration-engine/integrations.js'
import { normalizeInstalledIds } from '@core-engine/installable/protocol/normalize-installed-ids.js'
import { isIntegrationId } from '@next-adapter/integration-registry.js'

export function normalizeInstalledIntegrations(
  config: ResolvedBetterstartConfig
): BetterstartIntegrationId[] {
  return normalizeInstalledIds(config.integrations.installed, isIntegrationId)
}
